import { render, staticRenderFns } from "./MyAdvancedSecurity.vue?vue&type=template&id=6c49ae7c"
import script from "./MyAdvancedSecurity.vue?vue&type=script&lang=js"
export * from "./MyAdvancedSecurity.vue?vue&type=script&lang=js"
import style0 from "./MyAdvancedSecurity.vue?vue&type=style&index=0&id=6c49ae7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports